// Заказы к договорам
import { get, post, put, patch } from 'helpers/api_helper';
import { errorToast, successToast } from 'components';

// Получить заказы договоров
export const getContractOrders = async () => {
	try {
		const response = await get('/outstaff/contract_orders/');
		return response;
	} catch (error) {
		errorToast('Произошла ошибка при загрузке заказов.');
	}
}

// параметры фильтрации заказов
export const getContractOrdersParams = async (...filterObjects) => {
	const combinedFilters = Object.assign({}, ...filterObjects);
	const params = new URLSearchParams();

	for (const key in combinedFilters) {
		if (combinedFilters[key]) {
			params.append(key, combinedFilters[key]);
		}
	}

	const url = `/outstaff/contract_orders/?${params.toString()}`;

	try {
		const response = await get(url);
		return response;
	} catch (error) {
		errorToast('Произошла ошибка при загрузке заказов.');
	}
}

// загрузка всех оплат заказов
export const getOrderPayments = async () => {
	try {
		const response = await get('/outstaff/contract_order_payment/');
		return response;
	} catch (error) {
		errorToast('Произошла ошибка при загрузке оплат.');
	}
}

// параметры фильтрации оплат заказов
export const getOrderPaymentsParams = async (...filterObjects) => {
	const combinedFilters = Object.assign({}, ...filterObjects);
	const params = new URLSearchParams();

	for (const key in combinedFilters) {
		if (combinedFilters[key]) {
			params.append(key, combinedFilters[key]);
		}
	}

	const url = `/outstaff/contract_order_payment/?${params.toString()}`;

	try {
		const response = await get(url);
		return response;
	} catch (error) {
		errorToast('Произошла ошибка при загрузке оплат заказов.');
	}
}

// оплата заказов
export const addContractOrderPayment = async (data) => {
	try {
		const response = await post('/outstaff/contract_order_payment/', data);
		successToast('Заказ оплачен.');
		return response;
	} catch (error) {
		errorToast('Произошла ошибка при оплате заказа.');
	}
}